import React, { useState, useEffect } from "react";
import "./Projetos.css";

export default function Projetos() {
  const projetos = [
    { nome: "Loja Destroyer", link: "https://www.lojadestroyer.com.br/" },
    { nome: "Meteora", link: "https://meteora-gold-two.vercel.app/" },
    { nome: "Olá Mundo", link: "https://ola-mundo-orpin.vercel.app/" },
    { nome: "Spotifly", link: "https://spotifly-blush.vercel.app/" },
    { nome: "Space App", link: "https://space-app-alpha-seven.vercel.app/" },
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const nextSlide = () => {
    setFade(false);
    setTimeout(() => {
      setIndex((prev) => (prev === projetos.length - 1 ? 0 : prev + 1));
      setFade(true);
    }, 400);
  };

  const prevSlide = () => {
    setFade(false);
    setTimeout(() => {
      setIndex((prev) => (prev === 0 ? projetos.length - 1 : prev - 1));
      setFade(true);
    }, 400);
  };

  useEffect(() => {
    const timer = setInterval(() => nextSlide(), 8000);
    return () => clearInterval(timer);
  }, [index]);

  return (
    <section className="projetos-section">
      <h1>Conheça alguns dos nossos projetos</h1>

      <div className="projetos-container">
        {/* SLIDE + CLICK PARA ABRIR O SITE */}
        <div
          className="projetos-slide"
          onClick={() => window.open(projetos[index].link, "_blank")}
          style={{ cursor: "pointer" }}
        >
          <button
            className="seta-btn"
            onClick={(e) => {
              e.stopPropagation();
              prevSlide();
            }}
          >
            ❮
          </button>

          <div className={`iframe-container ${fade ? "fade-in" : "fade-out"}`}>
            <iframe
              src={projetos[index].link}
              title={projetos[index].nome}
              loading="lazy"
            ></iframe>
          </div>

          <button
            className="seta-btn"
            onClick={(e) => {
              e.stopPropagation();
              nextSlide();
            }}
          >
            ❯
          </button>
        </div>

        {/* TEXTO AO LADO */}
        <div className="projetos-texto">
          <p>
            Clique e conheça os projetos que desenvolvemos para nossos clientes.
          </p>
          <div className="seta-lado">←</div>
        </div>
      </div>

      {/* BOTÃO ABAIXO */}
      <a
        href="https://wa.me/5511988833017"
        target="_blank"
        rel="noopener noreferrer"
        className="botao-orcamento"
      >
        Fale com um especialista
      </a>
    </section>
  );
}
